import * as RadixPopover from "@radix-ui/react-popover";
import classNames from "classnames/bind";
import React from "react";
import styles from "./Popover.module.scss";
import type { PopoverProps } from "./types";

const cx = classNames.bind(styles);

const Popover = ({
  children,
  contentClassName,
  contentRender,
  rootProps,
  contentProps,
  shouldDisplayArrow = false,
}: PopoverProps) => {
  const { colorVariant, ...restContentProps } = contentProps ?? {};

  return (
    <RadixPopover.Root {...rootProps}>
      <RadixPopover.Trigger asChild>{children}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content
          className={cx(
            "popover-content",
            colorVariant && `is-color-${colorVariant}`,
            contentClassName
          )}
          sideOffset={2}
          collisionPadding={16}
          {...restContentProps}
        >
          {contentRender?.() ?? null}
          {shouldDisplayArrow ? (
            <RadixPopover.Arrow
              className={cx(
                "popover-arrow",
                colorVariant && `is-color-${colorVariant}`
              )}
            />
          ) : null}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
};

export default Popover;
